"use strict";

module.exports = [
    "$filter", function($filter) {
        var angularDateFilter = $filter("date");
        return function (date, format) {
            return angularDateFilter(date, format, "UTC");
        }
    }
];